class AutorBestseller extends HTMLElement {
    connectedCallback() {
        const alleArtikelDesAutors = document.querySelector('.alle-artikel-des-autors');
        if (alleArtikelDesAutors) this.initAlleArtikelButton();
    }

    initAlleArtikelButton() {
        this.alleArtikelButton = this.querySelector('[interaction="alle-buecher-anzeigen"]');
        this.alleArtikelButton.setAttribute('data-status', 'aktiv');
        this.alleArtikelButton.addEventListener('click', () => { this.alleArtikelKlickHandler() })
    }

    alleArtikelKlickHandler() {
        const alleArtikelDesAutors = document.querySelector('.alle-artikel-des-autors');
        if (alleArtikelDesAutors) {
            alleArtikelDesAutors.scrollIntoView({ behavior: "smooth" });
        }
    }
}

if (!customElements.get("autor-bestseller")) {
    customElements.define("autor-bestseller", AutorBestseller);
}
